<template>
  <div class="forgot-password-content">
    <Form ref="observer" v-slot="{ meta }" class="form-block" @submit="submitForgotPassword">
      <div>
        <Field v-slot="{ field, errorMessage, handleChange, validate }" v-model="email" name="email" :rules="rules.email">
          <div class="form__input">
            <p class="input-label mb-2">{{ $t('all_account') }}</p>
            <v-text-field
              :model-value="field.value"
              class="mb-4"
              :placeholder="$t('account_hint')"
              :min-height="40"
              :color="'orange50'"
              :error-messages="errorMessage"
              :hide-details="errorMessage?.length === 0"
              variant="outlined"
              density="compact"
              @update:model-value="handleChange"
              @blur="validate"
            />
          </div>
        </Field>
      </div>

      <div class="forget__hint pb-14">
        <p class="mb-2">{{ $t('forgot_pwd_remark1') }}</p>
        <p class="ma-0">{{ $t('forgot_pwd_remark2') }}</p>
      </div>

      <success-in-dialog ref="successInDialog" class="mb-3" :success-text="$t('snackbar_reset_pwd_email')" />

      <dialog-error v-model:show-status="hasError" class="mb-3" :error="error" />

      <v-btn class="forgot-password__btn mb-5" :class="{ disabled: !meta.valid }" :height="40" type="submit" color="orange50" variant="flat" block>
        <loading v-if="forgotPasswordLoading" />
        <span v-else> {{ $t('all_send') }} </span>
      </v-btn>
    </Form>

    <div class="dialog-footer text-center">
      <v-divider class="my-5" />

      <v-btn class="other-way__btn" :height="24" color="orange50" variant="text" @click="changeIndexPage">
        {{ $t('forgot_pwd_back') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/icons/loading'
import SuccessInDialog from '@/components/notice/success/success-in-dialog'
import DialogError from '@/components/notice/error/dialog-error'

export default {
  name: 'ForgotPassword',
  components: {
    Loading,
    SuccessInDialog,
    DialogError,
  },
  emits: ['changeAuthStep'],
  setup() {
    const rules = useFieldRules()

    return {
      rules: {
        email: rules.email(),
      },
    }
  },
  data() {
    return {
      forgotPasswordLoading: false,
      showPassword: false,
      disableBtn: true,
      email: '',
      hasError: false,
      error: {},
    }
  },
  methods: {
    clearError() {
      this.hasError = false
      this.error = {}
    },
    changeIndexPage() {
      this.$emit('changeAuthStep', 'index')
    },
    getForgotPasswordData() {
      return {
        email: this.email,
      }
    },
    submitForgotPassword() {
      this.$refs.observer.validate().then(({ valid }) => {
        if (valid && !this.forgotPasswordLoading) {
          this.loginLoading = true
          this.dispatchForgotPassword()
        }
      })
    },
    dispatchForgotPassword() {
      this.clearError()
      this.forgotPasswordLoading = true
      this.$refs.successInDialog.hide()
      const forgotPasswordData = this.getForgotPasswordData()
      this.$store
        .dispatch('authentication/forgotPassword', forgotPasswordData)
        .then(res => {
          this.forgotPasswordLoading = false
          this.$refs.successInDialog.show()
        })
        .catch(error => {
          this.forgotPasswordLoading = false
          this.hasError = true
          this.error = this.getErrorCodeStatus(error.code) || error
          console.error(error)
        })
    },
    getErrorCodeStatus(code) {
      switch (code) {
        case 'offline':
          return false
        case 16:
          return this.$t('snackbar_no_account')
        default:
          return false
      }
    },
  },
}
</script>
<style scoped lang="scss">
.forgot-password-content {
  max-height: calc(75vh - 146px);
  overflow-y: auto;
  .form-block {
    .input-label {
      font-size: 13px;
    }
  }

  .forget__hint {
    font-size: 13px;
    color: $gray80;
  }

  .forgot-password__btn {
    font-size: 17px;
    &.disabled {
      background-color: $orange30 !important;
      pointer-events: none;
    }
  }

  .dialog-footer {
    .question-hint {
      line-height: 24px;
      .login-text {
        cursor: pointer;
      }
    }
    .question-hint,
    .other-way__btn {
      font-size: 13px;
    }
  }
}
</style>
